import { Event } from "../dtos/event";

// Utility to determine if a user is deleted based on Event object properties
export function isEventUserDeleted(event: Event): boolean {
    const { accountType, isEmployeeDeleted, isCustomerDeleted } = event;
    if (accountType === "Employee") {
        return Boolean(isEmployeeDeleted);
    }
    if (accountType === "Customer") {
        return Boolean(isCustomerDeleted);
    }
    return false;
}
